import React from 'react';
import { Recipe } from 'utils/grocyApi.ts';
import { RecipeFulfillmentStatus } from './recipeFulfillment.ts';
import './RecipeListItem.css';

interface RecipeListItemProps {
  recipe: Recipe;
  stockStatus: RecipeFulfillmentStatus;
  onClick: () => void;
}

const RecipeListItem: React.FC<RecipeListItemProps> = ({ recipe, stockStatus, onClick }) => {
  const getStatusInfo = () => {
    if (stockStatus.isFullyAvailable) {
      return { color: 'var(--color-success)', text: 'Available' };
    } else if (stockStatus.isFullyCoveredByShoppingList) {
      return { color: 'var(--color-primary)', text: 'On list' };
    } else if (stockStatus.isPartiallyCoveredByShoppingList) {
      return { color: 'var(--color-warning)', text: 'Partially on list' };
    } else {
      return { color: 'var(--color-danger)', text: `${stockStatus.missingIngredients} missing` };
    }
  };

  const { color, text } = getStatusInfo();

  return (
    <div className="recipe-list-item" onClick={onClick}>
      <div className="recipe-list-item__content">
        <div className="recipe-list-item__name">
          {recipe.name}
        </div>
        <div className="recipe-list-item__status">
          <span className="recipe-list-item__dot" style={{ background: color }} />
          <span className="recipe-list-item__text" style={{ color }}>{text}</span>
        </div>
      </div>
    </div>
  );
};

export default RecipeListItem;
